import { render } from "./AddToWish.vue?vue&type=template&id=be859e96&scoped=true"
import script from "./AddToWish.vue?vue&type=script&lang=ts"
export * from "./AddToWish.vue?vue&type=script&lang=ts"

import "./AddToWish.vue?vue&type=style&index=0&id=be859e96&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-be859e96"

export default script